import { render, staticRenderFns } from "./PendingTrainingsApproveDialog.vue?vue&type=template&id=775ee9d0"
import script from "./PendingTrainingsApproveDialog.vue?vue&type=script&lang=ts"
export * from "./PendingTrainingsApproveDialog.vue?vue&type=script&lang=ts"
import style0 from "./PendingTrainingsApproveDialog.vue?vue&type=style&index=0&id=775ee9d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports